import { IStructuresAllData } from "store/location/location-model";
import { IUserData } from "store/user-session/user-session-model";
import { isNull, searchLocationByIdSelected } from "utils/functions";
import { getTimeZoneName } from "utils/intl/getLocale";

export interface IExportReport {
  formReport: any;
  locationStructure: IStructuresAllData;
  location: string[] | any;
  reportFetchAsync: (...args) => void;
  locationByStructureIdList: IStructuresAllData[];
  message: string | any;
  messageDescription: string;
  userData: IUserData;
}

export interface IQueryReport {
  formReport: any;
  locationStructure: IStructuresAllData;
  location: string[] | any;
  reportFetchRegisterAsync: (...args) => void;
  locationByStructureIdList: IStructuresAllData[];
  message: string | any;
  messageDescription: string;
  itemsByPage: number;
  pageIndex: number;
  userData: IUserData;
}

export interface IReport {
  structure: IStructuresAllData;
  rangePicker: string[] | any;
}

export interface IReportRequest {
  locations?: string[];
  _minEventTime: string;
  _maxEventTime: string;
  locationTimeZone: string;
  structureId: number | any;
  trailerPlate?: string;
  document?: string;
  plate?: string;
}

export interface IQueryReportRequest {
  locations?: string[];
  initialEventTime: string;
  finalEventTime: string;
  structureId: number | any;
  itemsByPage: number;
  pageIndex: number;
  trailerPlate?: string;
  document?: string;
  plate?: string;
}

const dateFormat = "YYYY-MM-DD";

export const onConfirmExportReport = async ({
  formReport,
  locationStructure,
  location,
  reportFetchAsync,
  message,
  messageDescription,
  locationByStructureIdList,
  userData,
}: IExportReport) => {
  try {
    await formReport.validateFields();
    const rangePicker = formReport.getFieldValue("rangePicker");
    const plate = formReport.getFieldValue("plate");
    const trailerPlate = formReport.getFieldValue("trailerPlate");
    const document = formReport.getFieldValue("document");
    let bodyRequest: IReportRequest = {
      _minEventTime: rangePicker[0].format(dateFormat),
      _maxEventTime: rangePicker[1].format(dateFormat),
      locationTimeZone: getTimeZoneName(),
      structureId: locationStructure,
      trailerPlate: isNull(trailerPlate),
      document: isNull(document),
      plate: isNull(plate),
    };
    if (isNull(location) !== null) {
      const exportLocationId = searchLocationByIdSelected(location, locationByStructureIdList, userData);
      bodyRequest = { ...bodyRequest, locations: exportLocationId };
    }
    reportFetchAsync(bodyRequest);
  } catch (e) {
    message.error(messageDescription);
  }
};

export const onConfirmQueryReport = async ({
  formReport,
  locationStructure,
  location,
  reportFetchRegisterAsync,
  message,
  messageDescription,
  itemsByPage,
  pageIndex,
  locationByStructureIdList,
  userData,
}: IQueryReport) => {
  try {
    await formReport.validateFields();
    const rangePicker = formReport.getFieldValue("rangePicker");
    const plate = formReport.getFieldValue("plate");
    const trailerPlate = formReport.getFieldValue("trailerPlate");
    const document = formReport.getFieldValue("document");

    let bodyRequest: IQueryReportRequest = {
      initialEventTime: rangePicker[0].format(dateFormat),
      finalEventTime: rangePicker[1].format(dateFormat),
      structureId: locationStructure,
      itemsByPage,
      pageIndex,
      trailerPlate: isNull(trailerPlate),
      document: isNull(document),
      plate: isNull(plate),
    };
    if (isNull(location) !== null) {
      const queryLocationId = searchLocationByIdSelected(location, locationByStructureIdList, userData);
      bodyRequest = { ...bodyRequest, locations: queryLocationId };
    }
    reportFetchRegisterAsync(bodyRequest);
  } catch (e) {
    message.error(messageDescription);
  }
};
